import { Url } from 'next/dist/shared/lib/router/router';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useFindFundByFundCode } from '@/modules/invest/subModules/fund/hooks/useFindFund';

export const useGetTransactionsListUrl = () => {
  const fundCode = useGetFundCodeFromQuery();

  const { fund } = useFindFundByFundCode(fundCode);

  const url: Url =
    fund?.fundType === 'ETF'
      ? {
          pathname: '/invest/etf/transactions',
          query: { Isin: fundCode },
        }
      : {
          pathname: '/invest/fund/transaction',
          query: { fundCode },
        };

  return url;
};
